<template>
  <v-list-item class="item">
    <div class="item__title">{{ item.name }}</div>
    <div class="item__actions" v-if="$slots['actions']">
      <v-menu left :offset-x="true" origin="left top" nudge-top="11">
        <template #activator="{ on }">
          <v-icon v-on="on">icon-more </v-icon>
        </template>
        <slot name="actions"></slot>
      </v-menu>
    </div>
  </v-list-item>
</template>

<script>
export default {
  name: "ExpansionListItem",
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.item {
  @include font-size(14px);
  padding: $spacing 0;
  display: flex;
  justify-content: space-between;

  &:not(:last-child) {
    border-bottom: 1px solid rgba($text, 0.1);
  }

  &__title {
    font-weight: 600;
  }

  &__actions {
    display: flex;
    align-items: center;
    margin-right: $spacing * 0.5;
    margin-left: auto;
  }
}
</style>
